import { HFlow, VFlow } from 'bold-ui'
import { DateField, TextAreaField } from 'components/form'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import { ExameQueryModel, ResultadoExameEspecificoModel } from '../../model'
import { getResultadoExameEspecificoField } from '../../util'

interface ResultadoExameEspecificoFieldProps {
  name: MetaPath<ResultadoExameEspecificoModel>
  exame: ExameQueryModel
  hasSolicitacao?: boolean
}

export const ResultadoExameEspecificoField = (props: ResultadoExameEspecificoFieldProps) => {
  const { name, exame, hasSolicitacao } = props

  const ResultadoExameEspecificoField = getResultadoExameEspecificoField(exame)

  return (
    ResultadoExameEspecificoField && (
      <VFlow>
        <ResultadoExameEspecificoField name={name.resultado} exame={exame} />

        <TextAreaField name={name.descricao} label='Descrição' />

        <HFlow>
          {!hasSolicitacao && <DateField name={name.dataSolicitado} label='Solicitado em' />}

          <DateField name={name.dataRealizado} label='Realizado em' required />

          <DateField name={name.dataResultado} label='Resultado em' />
        </HFlow>
      </VFlow>
    )
  )
}
